import { useEffect, useState } from "react";

const getBreakpoint = (width: number): string => {
  if (width < 640) return "xs";
  if (width < 768) return "sm";
  if (width < 1024) return "md";
  return "lg";
};

export const useScreenSize = (onChange?: (size: string) => void) => {
  // Initialize with the true initial window width immediately
  const [screenSize, setScreenSize] = useState(() => 
    typeof window !== "undefined" ? getBreakpoint(window.innerWidth) : "xs"
  );

  useEffect(() => {
    let changeTimeout: ReturnType<typeof setTimeout> | null = null;

    const handleResize = () => {
      const currentSize = getBreakpoint(window.innerWidth);
      setScreenSize((prevSize) => {
        if (currentSize !== prevSize) {
          if (onChange) onChange(currentSize);
          return currentSize;
        }
        return prevSize;
      });
    };

    const onResize = () => {
      if (changeTimeout !== null) {
        clearTimeout(changeTimeout);
      }
      changeTimeout = setTimeout(handleResize, 400);
    };

    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
      if (changeTimeout !== null) {
        clearTimeout(changeTimeout);
      }
    };
  }, [onChange]); 

  return screenSize;
};